import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';

import { useState, useRef, useEffect } from 'react';
import { useCallback } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import roundThumbUp from '@iconify/icons-ic/round-thumb-up';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
import moreHorizontalFill from '@iconify/icons-eva/more-horizontal-fill';
// material
import { MobileDateRangePicker, LoadingButton } from '@material-ui/lab';
import { styled } from '@material-ui/core/styles';
import {
    Box,
    Stack,
    Drawer,
    Button,
    Avatar,
    Tooltip,
    Divider,
    MenuItem,
    TextField,
    Typography,
    OutlinedInput,
    Grid,
    Card,
    Tabs,
    Tab,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    InputAdornment,
    Autocomplete
} from '@material-ui/core';
//

import { MIconButton, MHidden } from '../../../components/@material-extend';
import apiContact from '../../../api/contact';
import apiUser from '../../../api/user';
import { useSnackbar } from 'notistack5';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------
import useAuth from '../../../hooks/useAuth'
import { objectID } from '../../../utils/objectID';
import { useSelector } from 'react-redux';

import { capitalCase } from 'change-case';
import Scrollbar from '../../../components/Scrollbar';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
const PRIORITIZES = ['low', 'medium', 'hight'];

FCustomer.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    card: PropTypes.object,
    onDeleteTask: PropTypes.func
};

const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    width: 140,
    fontSize: 13,
    flexShrink: 0,
    color: theme.palette.text.secondary
}));

// ----------------------------------------------------------------------
export default function FCustomer({ isOpen, onClose, formik, selectedTicket, isReadOnly, quickInfoContactAdd }) {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik
    const [customer, setCustomer] = useState({ nameProfile: "Phuongtest", role: "Programmer" });
    const [listContact, setListContact] = useState([]);
    useEffect(() => {
        const listContactSys = async () => {
            try {
                const res = await apiContact.view();
                setListContact(res.data.data);
            } catch (error) {
                enqueueSnackbar("Không tìm thấy danh dạ!!!", { variant: 'error' });
            }
        }
        listContactSys();
    }, []);
    const handleChangeListContact = (item) => {
        setFieldValue('customer_phone', item ? item?.phone : "");
        setFieldValue('customer_email',item && item.hasOwnProperty('email') ? item?.email : "");
        setFieldValue('customer_name', item ? item?.name : "");
    }
    return (
        <>
            <Box
                sx={{
                    '& > :not(style)': { m: 1, },
                }}
            >
                {!selectedTicket && !quickInfoContactAdd ? <Autocomplete
                    disabled={isReadOnly}
                    fullWidth
                    size="small"
                    limitTags={1}
                    id="checkboxes-tags-demo"
                    name="list_contact"
                    options={listContact}
                    getOptionLabel={(option) => option?.name}
                    onChange={(event, item) => handleChangeListContact(item)}
                    isOptionEqualToValue={(option, item) => option?.phone === item?.phone}

                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label={t('select_contact')}
                            placeholder={t('options')}
                            {...getFieldProps('customer_name')}

                        />
                    )}
                /> : <TextField
                    disabled={isReadOnly}
                    id="outlined-basic"
                    size="small"
                    fullWidth label="Tên khách hàng"
                    variant="outlined"
                    {...getFieldProps('customer_name')}
                    InputProps={{
                        endAdornment: <InputAdornment position="start"><PersonIcon /></InputAdornment>,
                    }}
                    error={Boolean(touched.customer_name && errors.customer_name)}
                    helperText={touched.customer_name && errors.customer_name}
                />}
                <TextField
                    disabled={isReadOnly}
                    id="outlined-basic"
                    size="small"
                    fullWidth label="Email"
                    variant="outlined"
                    {...getFieldProps('customer_email')}
                    error={Boolean(touched.customer_email && errors.customer_email)}
                    helperText={touched.customer_email && errors.customer_email}
                />
                <TextField
                    disabled={isReadOnly}
                    size="small"
                    id="standard-basic"
                    fullWidth label="SĐT"
                    variant="outlined"
                    {...getFieldProps('customer_phone')}
                    error={Boolean(touched.customer_phone && errors.customer_phone)}
                    helperText={touched.customer_phone && errors.customer_phone}
                />
            </Box>
        </>
    );
}
